import { gql } from 'apollo-angular'

import { AUTHOR_EXTENDED_FIELDS } from '../../fragments/author.fragments'

export const GET_AUTHORS = gql`
  ${AUTHOR_EXTENDED_FIELDS}
  query getAuthors(
    $page: Int!
    $limit: Int!
    $sort: String
    $where: Author_where
  ) {
    Authors(page: $page, limit: $limit, sort: $sort, where: $where) {
      docs {
        ...AuthorExtendedFields
      }
      totalDocs
      totalPages
      page
    }
  }
`
